module.exports = __webpack_public_path__ + "static/to_top-ad8fad6f502894eaec94fcc3f6968d4f.jpg";